/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
import { ResourceType } from './ResourceType';

/**
 * Enumeration of configuration resource properties.
 */
export class ConfigResourceProps {
  static SUBMISSION_VALIDATION_SCHEMA = new ConfigResourceProps(
    'submissionValidationSchema',
    '/form/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_UI_SCHEMA = new ConfigResourceProps(
    'submissionUiSchema',
    '/form/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_SA_UI_SCHEMA = new ConfigResourceProps(
    'saUiSchema',
    '/form/dialogs/subsequent-actions/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_SA_VALIDATION_SCHEMA = new ConfigResourceProps(
    'saValidationSchema',
    '/form/dialogs/subsequent-actions/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_SPC_UI_SCHEMA = new ConfigResourceProps(
    'spcUiSchema',
    '/form/dialogs/spc/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_SPC_VALIDATION_SCHEMA = new ConfigResourceProps(
    'spcValidationSchema',
    '/form/dialogs/spc/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_AUTOFILL_VALIDATION_SCHEMA = new ConfigResourceProps(
    'autofillSubmissionValidationSchema',
    '/form/dialogs/autofill/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_AUTOFILL_UI_SCHEMA = new ConfigResourceProps(
    'autofillSubmissionUiSchema',
    '/form/dialogs/autofill/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static ATTACHMENT_CONFIGURATION = new ConfigResourceProps(
    'attachmentsConfiguration',
    '/config/attachmentTypes.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static FRONTEND_CUSTOMISATION = new ConfigResourceProps(
    'frontendCustomisation',
    '/frontendCustomisation.json',
    ResourceType.GENERIC,
  );
  static PARTIES_CONFIGURATION = new ConfigResourceProps(
    'partiesConfiguration',
    '/procedures/common/config/parties.json',
    ResourceType.GENERIC,
  );
  static GLOBAL_CONFIGURATION = new ConfigResourceProps('globalConfig', '/config-default.json', ResourceType.ROOT);
  static ADDRESSBOOK_VALIDATION_SCHEMA = new ConfigResourceProps(
    'addressBookValidationSchema',
    '/modules/address-book/form/schema.jsonschema',
    ResourceType.GENERIC,
  );
  static ADDRESSBOOK_UI_SCHEMA = new ConfigResourceProps(
    'addressBookUiSchema',
    '/modules/address-book/form/uiSchema.json',
    ResourceType.GENERIC,
  );
  static ORGANIZATION_VALIDATION_SCHEMA = new ConfigResourceProps(
    'organizationValidationSchema',
    '/modules/user-management/form/organization-profile/schema.jsonschema',
    ResourceType.GENERIC,
  );
  static ORGANIZATION_UI_SCHEMA = new ConfigResourceProps(
    'organizationUiSchema',
    '/modules/user-management/form/organization-profile/uiSchema.json',
    ResourceType.GENERIC,
  );
  static USEREDIT_VALIDATION_SCHEMA = new ConfigResourceProps(
    'userEditValidationSchema',
    '/modules/user-management/form/user-profile/schema.jsonschema',
    ResourceType.GENERIC,
  );
  static USEREDIT_UI_SCHEMA = new ConfigResourceProps(
    'userEditUiSchema',
    '/modules/user-management/form/user-profile/uiSchema.json',
    ResourceType.GENERIC,
  );
  static ADDRESSBOOK_TABLE_CONFIGURATION = new ConfigResourceProps(
    'addressBookTableConfiguration',
    '/modules/address-book/config/contactsTable.json',
    ResourceType.GENERIC,
  );
  static USERS_TABLE_CONFIGURATION = new ConfigResourceProps(
    'usersTableConfiguration',
    '/modules/user-management/config/usersTable.json',
    ResourceType.GENERIC,
  );
  static INVITATIONS_TABLE_CONFIGURATION = new ConfigResourceProps(
    'invitationsTableConfiguration',
    '/modules/user-management/config/invitationsTable.json',
    ResourceType.GENERIC,
  );
  static RECEIVING_OFFICES_CONFIGURATION = new ConfigResourceProps(
    'receivingOfficesConfiguration',
    '/config/receivingOffices.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static RECEIVING_OFFICES_LANGUAGE_CONFIGURATION = new ConfigResourceProps(
    'receivingOfficesLanguageConfiguration',
    '/config/receivingOfficesLanguages.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_TABLE_CONFIGURATION = new ConfigResourceProps(
    'tableConfiguration',
    '/config/submissionsTable.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static LANDING_PAGE_CONFIGURATION_EN = new ConfigResourceProps(
    'landingPage',
    '/modules/pages/landingPage-EN.html',
    ResourceType.GENERIC,
  );
  static LANDING_PAGE_CONFIGURATION_DE = new ConfigResourceProps(
    'landingPage',
    '/modules/pages/landingPage-DE.html',
    ResourceType.GENERIC,
  );
  static LANDING_PAGE_CONFIGURATION_LT = new ConfigResourceProps(
    'landingPage',
    '/modules/pages/landingPage-LT.html',
    ResourceType.GENERIC,
  );
  static LANDING_PAGE_CONFIGURATION_EL = new ConfigResourceProps(
    'landingPage',
    '/modules/pages/landingPage-EL.html',
    ResourceType.GENERIC,
  );
  static LANDING_PAGE_CONFIGURATION_ES = new ConfigResourceProps(
    'landingPage',
    '/modules/pages/landingPage-ES.html',
    ResourceType.GENERIC,
  );
  static ACCESSIBILITY_STATEMENT_CONFIGURATION_EN = new ConfigResourceProps(
    'accessibilityStatement',
    '/modules/pages/accessibilityStatement-EN.html',
    ResourceType.GENERIC,
  );
  static ACCESSIBILITY_STATEMENT_CONFIGURATION_LT = new ConfigResourceProps(
    'accessibilityStatement',
    '/modules/pages/accessibilityStatement-LT.html',
    ResourceType.GENERIC,
  );
  static ACCESSIBILITY_STATEMENT_CONFIGURATION_EL = new ConfigResourceProps(
    'accessibilityStatement',
    '/modules/pages/accessibilityStatement-EL.html',
    ResourceType.GENERIC,
  );
  static ACCESSIBILITY_STATEMENT_CONFIGURATION_ES = new ConfigResourceProps(
    'accessibilityStatement',
    '/modules/pages/accessibilityStatement-ES.html',
    ResourceType.GENERIC,
  );
  static SUBMISSION_PAYMENT_VALIDATION_SCHEMA = new ConfigResourceProps(
    'paymentValidationSchema',
    '/form/payment/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_PAYMENT_UI_SCHEMA = new ConfigResourceProps(
    'paymentUiSchema',
    '/form/payment/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static FEE_AMOUNTS_CONFIGURATION = new ConfigResourceProps(
    'feeAmountsConfiguration',
    '/procedures/common/config/fees.json',
    ResourceType.GENERIC,
  );
  static SUBMISSION_SIGNING_VALIDATION_SCHEMA = new ConfigResourceProps(
    'signingValidationSchema',
    '/form/signing/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static SUBMISSION_SIGNING_UI_SCHEMA = new ConfigResourceProps(
    'signingUiSchema',
    '/form/signing/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static CREATION_DIALOG_UI_SCHEMA = new ConfigResourceProps(
    'creationUiSchema',
    '/form/dialogs/creation/uiSchema.json',
    ResourceType.PROCEDURE_SPECIFIC,
  );
  static CREATION_DIALOG_VALIDATION_SCHEMA = new ConfigResourceProps(
    'creationValidationSchema',
    '/form/dialogs/creation/schema.jsonschema',
    ResourceType.PROCEDURE_SPECIFIC,
  );

  static findByName = name =>
    Object.getOwnPropertyNames(ConfigResourceProps)
      .filter(key => !Object.getOwnPropertyNames(class {}).includes(key))
      .map(key => ConfigResourceProps[key])
      .find(props => props.name === name);

  constructor(name, path, type) {
    this.name = name;
    this.path = path;
    this.type = type;
  }

  toString() {
    return `${this.name}`;
  }
}
